import { render, staticRenderFns } from "./shippingOrdersItem.vue?vue&type=template&id=2bd7b714"
import script from "./shippingOrdersItem.vue?vue&type=script&lang=js"
export * from "./shippingOrdersItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports